import { MLPageData } from '../../../datasets/store/mlTypes';
import { PdfSearchResults } from '../../document-viewer/store/types';

export enum ChatbotActionTypes {
    TOGGLE_CHATBOT_MODAL = 'TOGGLE_CHATBOT_MODAL',
    RESET_CHATBOT_MODAL = 'RESET_CHATBOT_MODAL',
    ASK_CHATBOT_STARTED = 'ASK_CHATBOT_STARTED',
    ASK_CHATBOT_SUCCESSFUL = 'ASK_CHATBOT_SUCCESSFUL',
    ASK_CHATBOT_FAILED = 'ASK_CHATBOT_FAILED',
    SET_AI_SORTED_RESULTS = 'SET_AI_SORTED_RESULTS',
    RESET_CHATBOT_RESULTS = 'RESET_CHATBOT_RESULTS'
}

export interface ChatbotState {
    chatbotModalOpen: boolean;
    chatbotLoading: boolean;
    aiAnswer: MLPageData;
    aiResults: PdfSearchResults;
}
